import {
  API_KYC_CHANGE_STATUS_FIELD,
  API_KYC_CONFIRM,
  API_KYC_LIST,
  API_KYC_PREMIUM,
  API_KYC_STARTER,
  API_USERS_LIST,
  API_USERS_LIST_APPROVED,
  API_USERS_LIST_DECLINED,
  API_USERS_LIST_PENDING,
  API_USERS_LIST_PREMIUM,
  API_USERS_LIST_STARTER,
} from "./apiPaths";
import axiosMiddleware from "./axiosMiddleware";
// --------------------------------------------------------------------------------
export const getAllUsersAPI = ({ limit, offset, from, to, agent }) => {
  let agentParam = agent ? `&agentId=${agent}` : "";
  return axiosMiddleware({
    method: "get",
    url: `${API_USERS_LIST}?limit=${limit}&offset=${offset}&from=${from}&to=${to}${agentParam}`,
  });
};
export const getPendingUsersAPI = ({ limit, offset }) => {
  return axiosMiddleware({
    method: "get",
    url: `${API_USERS_LIST_PENDING}?limit=${limit}&offset=${offset}`,
  });
};
export const getApprovedUsersAPI = ({ limit, offset }) => {
  return axiosMiddleware({
    method: "get",
    url: `${API_USERS_LIST_APPROVED}?limit=${limit}&offset=${offset}`,
  });
};
export const getDeclinedUsersAPI = ({ limit, offset }) => {
  return axiosMiddleware({
    method: "get",
    url: `${API_USERS_LIST_DECLINED}?limit=${limit}&offset=${offset}`,
  });
};
export const getKnowYourCustomerAPI = ({ customerId }) => {
  let postData = {
    userId: customerId,
  };
  return axiosMiddleware({
    method: "post",
    url: API_KYC_LIST,
    data: postData,
  });
};
export const changeStatusKycFieldAPI = ({ id, status, description }) => {
  let postData = {
    id,
    status,
    error_message: description,
  };
  return axiosMiddleware({
    method: "post",
    url: API_KYC_CHANGE_STATUS_FIELD,
    data: postData,
  });
};
export const confirmKycAPI = ({ userId }) => {
  let postData = {
    userId,
  };
  return axiosMiddleware({
    method: "post",
    url: API_KYC_CONFIRM,
    data: postData,
  });
};
export const makeStarterUserAPI = ({ userId }) => {
  let postData = {
    userId,
  };
  return axiosMiddleware({
    method: "post",
    url: API_KYC_STARTER,
    data: postData,
  });
};
export const makePremiumUserAPI = ({ userId }) => {
  let postData = {
    userId,
  };
  return axiosMiddleware({
    method: "post",
    url: API_KYC_PREMIUM,
    data: postData,
  });
};
export const getStarterUsersAPI = ({ limit, offset }) => {
  return axiosMiddleware({
    method: "get",
    url: `${API_USERS_LIST_STARTER}?limit=${limit}&offset=${offset}`,
  });
};
export const getPremiumUsersAPI = ({ limit, offset }) => {
  return axiosMiddleware({
    method: "get",
    url: `${API_USERS_LIST_PREMIUM}?limit=${limit}&offset=${offset}`,
  });
};
